import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { SplitOverflowLabel } from './OverflowLabel';
import { TaskBarComponent } from './TaskBar';

import styles from './Taskbar.module.css';

export function TaskBarSelect({
  label,
  value,
  onChange,
  values,
  fullWidth = false,
  disabled = false,
  classes = {},
}: {
  value: string;
  onChange: (event) => void;
  values: Array<{ value: string; label: string; disabled?: boolean }>;
  label?: React.ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
  classes?: {
    paper?: string;
    menuItem?: string;
  };
}) {
  const selectEl = (
    <Select
      className={
        fullWidth
          ? styles.task_bar_select_fullwidth
          : styles.task_bar_select_wide
      }
      value={value}
      onChange={onChange}
      size="small"
      disabled={disabled}
      MenuProps={{ PaperProps: { className: classes?.paper } }}
    >
      {values.map((option) => (
        <MenuItem
          className={classes?.menuItem}
          key={option.value}
          value={option.value}
          disabled={option?.disabled}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );

  const wrappedSelect = label ? (
    <SplitOverflowLabel label={label}>{selectEl}</SplitOverflowLabel>
  ) : (
    selectEl
  );

  return <TaskBarComponent>{wrappedSelect}</TaskBarComponent>;
}
